// extracted by mini-css-extract-plugin
module.exports = {"marketing-header":"marketing-header__marketing-header___zm3i1"};